export default __webpack_public_path__ + "static/media/not-found-404.92de3a99.svg";